import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=485f5274&"
import script from "./MessageList.vue?vue&type=script&lang=ts&"
export * from "./MessageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports